import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { useDrawer } from 'providers/DrawerProvider';

import LINKS from 'constants/links';

const Drawer = dynamic(() => import('.'), { ssr: false });

const isCategoryDropdownEnabledAt = (pathname) =>
  pathname ? !pathname.includes(LINKS.BLOG) : true;

const DrawerRoot = () => {
  const { pathname } = useRouter();
  const {
    component: Component,
    isOpen,
    isOpenForTheFirstTime,
    hideDrawer,
    props,
  } = useDrawer();

  const onClose = () => hideDrawer({ direction: props.direction });

  if (!isOpenForTheFirstTime) {
    return null;
  }

  return (
    <Drawer isOpen={isOpen} onClose={onClose} {...props}>
      {Component ? (
        <Component
          categoryDropdown={isCategoryDropdownEnabledAt(pathname)}
          {...props}
        />
      ) : null}
    </Drawer>
  );
};

DrawerRoot.defaultProps = {
  pathname: null,
};

DrawerRoot.propTypes = {
  pathname: PropTypes.string,
};

export default DrawerRoot;
